import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import useFetch from '../../utils/useFetch'
import useQuery from '../../utils/useQuery'
import { ModalManagerContext } from '../ModalsManager'
import BaseContainer from '../common/BaseContainer'
import ControlHeader from '../common/ControlHeader'
import { ErrorMessage, useVisible } from '../common/AlertManager'
import Select from '../common/inputs/Select'
import FormsContainer from './FormsContainer'
import { campaignsUrl } from './config'
import useStyles from './styles'


const Questionnaire = () => {
  const [selectedCampaignId, setSelectedCampaignId] = useState()
  const openModal = useContext(ModalManagerContext)
  const { render } = useFetch(campaignsUrl, openModal)
  const [error, setError] = useState()
  const { visible: isErrorVisible, open: openError } = useVisible(false)
  const { t } = useTranslation(['translation'])
  const classes = useStyles()
  const query = useQuery()

  const alertCode = query.get('alertCode')

  useEffect(() => {
    if (alertCode) {
      setError({ resource: 'QUESTIONNAIRE', errorCode: alertCode })
      openError()
    }
  }, [alertCode])

  const getSplitId = (campaigns) => {
    const campaign = campaigns.find((c) => c._id === selectedCampaignId)
    return campaign?.splits[0].splitId
  }

  return (
    <BaseContainer>
      <ControlHeader
        title={t('QUESTIONNAIRE.TITLE')}
        showTabs
        activeTab="questionnaire"
      />
      <ErrorMessage error={error} visible={isErrorVisible} />
      {render(({ data: campaigns }) => (
        <>
          <div className={classes.questionnaireSelector}>
            <Select
              id='questionnaires'
              title={t('QUESTIONNAIRE.QUESTIONNAIRE_SELECTOR_TITLE')}
              value={selectedCampaignId}
              setFieldValue={(_, value) => setSelectedCampaignId(value)}
              options={Object.values(campaigns).map(c => ({ label: c.name, value: c._id }))}
              iconName="name"
            />
          </div>
          {selectedCampaignId && (
            <FormsContainer
              campaignId={selectedCampaignId}
              splitId={getSplitId(campaigns)}
            />
          )}
        </>
      ))}
    </BaseContainer>
  )
}

export default Questionnaire
